<template>
<div class="chapter">
<div class="inner_page">
<h2 class="TOC-FBMHD">Contents</h2>
<h2 class="TOCCT"><a href="#/c01">Kinchaku Drawstring Bag</a></h2>
<h2 class="TOCCT"><a href="#/c02">Shimacho Quilt</a></h2>
<h2 class="TOCCT"><span href="#/c03" title="Link target outside of Sample">Zabuton Floor Cushion</span></h2>
<h2 class="TOCCT"><span href="#/c04" title="Link target outside of Sample">Sashiko Samplers</span></h2>
<h2 class="TOCCT"><span href="#/c05" title="Link target outside of Sample">Sensu Quilt</span></h2>
<h2 class="TOCCT"><span href="#/c06" title="Link target outside of Sample">Sashiko Tote Bag</span></h2>
<h2 class="TOCCT"><span href="#/c07" title="Link target outside of Sample">Kimono Quilt</span></h2>
<h2 class="TOCCT"><span href="#/c08" title="Link target outside of Sample">Moyozashi Table Runner</span></h2>
<h2 class="TOCCT"><span href="#/c09" title="Link target outside of Sample">Sashiko Herb Pillow</span></h2>
<h2 class="TOCCT"><span href="#/c10" title="Link target outside of Sample">Koshi Sofa Throw</span></h2>
<h2 class="TOCCT"><span href="#/c11" title="Link target outside of Sample">Sashiko Patterns</span></h2>
<h2 class="TOCCT"><span href="#/ata" title="Link target outside of Sample">About the Author</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3fc0d6c0